export const ds_TileLayoutBlock_Entry = `
    fragment ds_TileLayoutBlock_Entry on ds_TileLayoutBlock_Entry {
        id
        canonicalUid
        tile_ColorTheme
        tile_ColorPalette
        tile_Heading
        tile_Subheading
        tile_TextSize
        tile_TextPosition
        tile_TextOnHover
        tile_SubHeadingColour
        tile_BorderAroundTile
        tile_DividerBeforeTile
        tile_ImageType
        tile_Height
      	tile_ContentPosition
        tile_CustomHeight
        tile_Padding
        tile_OverlayOpacity
        tile_OverlayOpacityHover
        tile_IconSize
        tile_Icon {
            type
            set
            name
        }

        tile_Link {
            text: linkText
            target
            url
            ariaLabel
            ... on tile_Link_Custom_LinkType {
                buttonStyle
            }
            ... on tile_Link_Entry_LinkType {
                buttonStyle
            }
            ... on tile_Link_Url_LinkType {
                buttonStyle
            }
            ... on tile_Link_Phone_LinkType {
                buttonStyle
            }
            ... on tile_Link_Email_LinkType {
                buttonStyle
            }
        }
        tile_Image {
            url @transform(width: 500, height: 500)
            alt
            focalPoint
        }
        tile_NumberCountAnimation
        tile_NumberCountPrefix
        tile_NumberCountValue
        tile_NumberCountSuffix
        tile_NumberCountColour
    }
`
